import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { create } from 'zustand';

// NOTE (TASK-01, context→zustand): file name kept as *Provider for now; it no
// longer renders a React Context provider. Renaming is handled by TASK-08.

interface INavigationHistoryStore {
  history: string[];
  pushPath: (path: string) => void;
  resetState: () => void;
}

export const useNavigationHistoryStore = create<INavigationHistoryStore>(
  (set) => ({
    history: [],
    // A new array is created on each push so subscribers re-render on
    // navigation — preserving the behaviour of the old provider, whose value
    // object changed identity on every location change.
    pushPath: (path) => set((state) => ({ history: [...state.history, path] })),
    resetState: () => set({ history: [] }),
  }),
);

// Backwards-compatible hook: consumers keep calling useNavigationHistory().
export const useNavigationHistory = () => {
  const history = useNavigationHistoryStore((state) => state.history);

  return { history };
};

// Mount once inside the Router. Records each visited pathname into the store.
// Replaces the old <NavigationHistoryProvider> wrapper.
export const NavigationHistoryTracker = (): null => {
  const location = useLocation();
  const pushPath = useNavigationHistoryStore((state) => state.pushPath);

  useEffect(() => {
    pushPath(location.pathname);
  }, [location, pushPath]);

  return null;
};
